export default __webpack_public_path__ + "static/media/8.7839fe02.png";